









































































import { Vue, Component, Lifecycle, Prop, p, Mixin } from "av-ts";
import { IOfferingUser, IOffering, IUser } from "../interfaces/models";
import { addEventsToQueue } from "../util";
import UserService from "../services/UserService";
import ImageService from "../services/ImageService";
import responsiveMixin from "./../responsiveMixin";
import Fetcher from "../services/Fetcher";

@Component
export default class UserContainer extends mixin(responsiveMixin, Vue) {
    @Prop offeringUser = p<IOfferingUser | undefined>({
        required: false
    });

    offerings: IOffering[] | undefined = undefined;

    updateOfferings(newOfferings: IOffering[]) {
        this.offerings = newOfferings;
    }

    get currentOffering() {
        if (this.offeringUser === undefined) {
            return undefined;
        }
        return this.offeringUser.offering;
    }

    set currentOffering(newOffering: IOffering | undefined) {
        this.$emit("changeOffering", newOffering);
    }

    get personalAvatar() {
        if (this.offeringUser !== undefined) {
            return this.offeringUser.user!.image;
        }
        return "";
    }

    get userFullName() {
        if (this.offeringUser === undefined) {
            return "Loading...";
        }
        return this.offeringUser.user!.name;
    }

    handleImageChange(input: HTMLInputElement) {
        return (e: Event) => {
            const newImages = (e.target as HTMLInputElement).files || [];
            if (newImages.length == 0) {
                // Snackbar err
                document.body.removeChild(input);
                this.showMessage("No file selected");
            } else {
                ImageService.fileToBase64EncodeString(newImages[0])
                    .then(file => UserService.updateUserImage({
                        newImage: (file as any).base64 as string
                    }))
                    .then((user: IUser) => {
                        this.$emit("changeUser", user);
                        UserService.getLoggedInUser()
                            .then((cu: IOfferingUser) => {
                                this.$emit("changeUser", cu.user);
                            });
                        this.showMessage("Profile image changed", "done");
                        document.body.removeChild(input);
                    })
                    .catch(_err => {
                        // this.showMessage(err);
                        document.body.removeChild(input);
                    });
            }
        };
    }

    openImagePicker() {
        if (!this.mobileMode) {
            const input = document.createElement("input");
            input.type = "file";
            input.addEventListener("change", (e: Event) => this.handleImageChange(input)(e));

            document.body.appendChild(input);
            input.dispatchEvent(new MouseEvent("click", {
                bubbles: false
            }));
        }
    }

    showMessage(message: string, icon: string = "error") {
        addEventsToQueue([{
            name: "Image Upload",
            description: message,
            icon: icon
        }]);
    }

    @Lifecycle
    created() {
        Fetcher.get(UserService.getUserOfferings)
            .on(this.updateOfferings);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getUserOfferings)
            .off(this.updateOfferings);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserContainer.vue